import { gql } from 'graphql.macro';

export const organizationUsageTemplate = gql`
    query organizationUsage($metric: String!) {
        organizationUsage(metric: $metric) {
            metric
            rows {
                dimension
                value
                unit
                calculatedAt
            }
            totalValue
            lastCalculatedAt
        }
    }
`;
